import { mpPartyElectorateText } from '../helpers';
import React from 'react';

const MPHeader = ({ mp, party, electorate }) => (
  <div className="row">
    <div className="col-9">
      <h2 className="h4 text-uppercase ">Write to {mp.name}</h2>
      {mpPartyElectorateText(mp, party, electorate)}
    </div>
    <div className="col-3 text-right">
      <img
        className="img-fluid border border-white rounded"
        alt={mp.name}
        style={{ height: '60px' }}
        src={mp.imageUrl}
      />
    </div>
  </div>
);

export default MPHeader;
